import React from 'react';
import { LuUsers, LuUserPlus } from 'react-icons/lu';
import { lazyPage } from '../lazyPage';

const Leads = lazyPage(() => import(/* webpackChunkName: "m-people" */ '../../components/Leads'));
const AddLead = lazyPage(() => import(/* webpackChunkName: "m-people" */ '../../components/AddLead'));
const LeadDetails = lazyPage(() => import(/* webpackChunkName: "m-people" */ '../../components/LeadDetails'));
const AddRequirement = lazyPage(() => import(/* webpackChunkName: "m-people" */ '../../components/AddRequirement'));
const EditRequirement = lazyPage(() => import(/* webpackChunkName: "m-people" */ '../../components/EditRequirement'));
// Org-scoped lead inbox (USER_LEAD_LIFECYCLE §1/§6) — source-aware list (incl.
// inbound WhatsApp/Wati) + the universal front-door create + convert.
const LeadInbox = lazyPage(() => import(/* webpackChunkName: "m-people" */ './pages/LeadInboxPage'));

/**
 * Leads feature manifest (wraps the existing legacy pages — no internals changed).
 *
 * NOTE: leads previously had NO sidebar entry — the pages were reachable only by
 * URL. This adds one, gated by `leads_mgmt` view permission (the same key
 * components/Leads.jsx already checks for its create button).
 */
const leadsManifest = {
    id: 'leads',
    featureName: 'leads_mgmt',
    permission: 'view',
    routes: [
        { path: '/leads', element: <Leads /> },
        { path: '/lead-inbox', element: <LeadInbox /> },
        { path: '/add-lead', element: <AddLead /> },
        { path: '/lead-details', element: <LeadDetails /> },
        { path: '/add-requirement/:id', element: <AddRequirement /> },
        { path: '/edit-requirement/:id/:leadId', element: <EditRequirement /> },
    ],
    sidebarItems: [
        { text: 'Leads', icon: <LuUsers />, link: '/leads' },
        { text: 'Lead Inbox', icon: <LuUserPlus />, link: '/lead-inbox' },
    ],
};

export default leadsManifest;
